const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:8000/api';

const LEADS = {
  CREATE_LEAD: (jobId) => `${API_BASE_URL}/leads/create/${jobId}/`,
  LEAD_STATS: `${API_BASE_URL}/leads/stats/`,
  UPDATE_STATUS: (leadId) => `${API_BASE_URL}/leads/update-status/${leadId}/`,
};

export default LEADS;